import { RESOLVE_APP, RESOLVE_APP_ERROR, RESOLVE_APP_SUCCESS, SET_HOST_STATE } from "./constants";

import produce from "immer";

// The initial state of this store.
const initialState = {
    isFetching: false,
    applicationId: null,
    currentHref: "",
    origin: "",
    currentPathname: "/",
    pathBeforeStore: "/",
    customer: null,
    applicationName: null,
    path: null,
    config: {},
    priceGroups: [],
    currency: null,
    languages: [],
    locale: null,
    ecommerceEnabled: false,
    state: null,
    device: null,
    defaultPriceList: {
        id: 1,
        code: "",
    },
};

export default produce((state, action) => {
    switch (action.type) {
        case RESOLVE_APP:
            state.isFetching = true;
            break;
        case RESOLVE_APP_SUCCESS:
            state.isFetching = false;
            state.applicationId = action.application.id;
            state.applicationName = action.application.name;
            state.path = action.application.path;
            state.config = action.config;
            state.priceGroups = action.priceGroups;
            state.currency = action.currency;
            state.languages = action.languages;
            state.locale = action.application.locale;
            state.ecommerceEnabled = action.application.locale === "en_US";
            state.device = action.device;
            state.defaultPriceList = action.defaultPriceList;
            break;
        case RESOLVE_APP_ERROR:
            state.isFetching = false;
            break;
        case SET_HOST_STATE:
            state.currentHref = action.currentHref;
            state.origin = action.origin;
            state.currentPathname = action.currentPathname;
            state.protocol = action.protocol;
            state.isSupportingWebp = action.isSupportingWebp;
            state.ipAddress = action.ipAddress;
            break;
        default:
            break;
    }
}, initialState);
